"use strict";
(self.webpackChunktvg_shopify_theme =
  self.webpackChunktvg_shopify_theme || []).push([
  ["4974"],
  {
    350: function (
      __unused_webpack_module,
      __unused_webpack___webpack_exports__,
      __webpack_require__
    ) {
      var events = __webpack_require__(6915),
        traversal = __webpack_require__(6985),
        main = __webpack_require__(9863),
        format_money = __webpack_require__(9194),
        init_section = __webpack_require__(1078),
        guards = __webpack_require__(9430);
      (0, init_section.initSection)(".js-product-sticky-bar", (section) => {
        let namespace = (0, events.makeEventNamespace)(),
          mainBus = (0, main.initMainBus)(),
          dynamicContentContainer = (0, traversal.findOneElement)(
            section,
            ".js-pdp-sticky-content"
          );
        if (!dynamicContentContainer)
          return {
            unload: () => {
              namespace.destroy();
            },
          };
        namespace.addDelegatedEventListener(
          section,
          ".js-pdp-\
sticky-action",
          "click",
          (target, evt) => {
            let targetId = target.getAttribute("href");
            if (!targetId) return;
            let targetElement = (0, traversal.findOneElement)(
              document,
              targetId
            );
            targetElement &&
              (evt.preventDefault(),
              window.scrollTo({
                top:
                  targetElement.getBoundingClientRect().top +
                  window.scrollY -
                  70,
                behavior: "smooth",
              }));
          }
        );
        let intersectionObserver = new IntersectionObserver(
            (entries) => {
              let intersectingEntry = entries.find(
                (entry) => entry.isIntersecting
              );
              if (!intersectingEntry) return;
              let intersectingElementStickyBarTitle =
                intersectingEntry.target.getAttribute("data-sticky-bar-title");
              intersectingElementStickyBarTitle &&
                (0, traversal.findElements)(
                  document,
                  ".js-pdp-sticky-action"
                ).forEach((action) => {
                  let actionTitle = action.getAttribute("data-title");
                  actionTitle &&
                    (actionTitle === intersectingElementStickyBarTitle
                      ? action.classList.add("active")
                      : action.classList.remove("active"));
                });
            },
            { threshold: 0.5 }
          ),
          sectionLinksMarkup = (0, traversal.findElements)(
            document,
            "[data-sticky-bar-title]"
          )
            .map((productSection, index) => {
              let sectionId =
                  productSection.getAttribute(
                    "i\
d"
                  ),
                title = productSection.getAttribute("data-sticky-bar-title");
              return title && sectionId
                ? (intersectionObserver.observe(productSection),
                  `
        <a
          href="#${0 === index ? "" : sectionId}"
          data-title="${title}"
          data-top="0"
          class="tvg_product_main_sticky_bar_N2rL1q_ProductStickyBar__content-action js-pdp-sticky-action">
          ${title}
        </a>
      `)
                : null;
            })
            .filter(guards.isPresent)
            .join("");
        return (
          (dynamicContentContainer.innerHTML = sectionLinksMarkup),
          mainBus
            .on("notification:selected-variant")
            .do(
              ({
                details: { product, selectedVariant: variant, selectedAddons },
              }) => {
                let priceContainer = (0, traversal.findOneElement)(
                  section,
                  '.js-price[data-product-id="' + product.id + '"]'
                );
                if (!priceContainer) return;
                let totalPrice =
                    variant.price +
                    selectedAddons.reduce(
                      (acc, addon) =>
                        acc +
                        ((addon.variants[0] && addon.variants[0].price) || 0),
                      0
                    ),
                  totalCompareAtPrice =
                    (variant.compare_at_price || 0) +
                    selectedAddons.reduce(
                      (acc, addon) =>
                        acc +
                        ((addon.variants[0] &&
                          (addon.variants[0].compare_at_price ||
                            addon.variants[0].price)) ||
                          0),
                      0
                    ),
                  priceHTML = `
        <span>
          ${(0, format_money.formatMoney)(
            totalPrice,
            "${{amount}}"
          )}
        </span>
        ${
          (totalCompareAtPrice || 0) > totalPrice
            ? `
          <del>${(0, format_money.formatMoney)(
            totalCompareAtPrice || 0,
            "${{amount}}"
          )}</del>
        `
            : ""
        }
      `;
                priceContainer.innerHTML = priceHTML;
              }
            ),
          {
            unload: () => {
              namespace.destroy(), intersectionObserver.disconnect();
            },
          }
        );
      });
    },
  },
  function (__webpack_require__) {
    __webpack_require__.O(0, ["8097"], function () {
      return __webpack_require__((__webpack_require__.s = "350"));
    }),
      __webpack_require__.O();
  },
]);
